import { DepartmentComponents } from './department';
import { NavItemsComponent } from './nav-item';
import { ProjectComponents } from './project';
import { ProgramComponents } from './program';
import { CategoryComponents } from './category';
import { StatusComponents } from './status';
import { RoomComponents } from './room';
import { RoomContentComponents } from './room-content';


export * from './nav-item';
export * from './department';
export * from './project';
export * from './program';
export * from './category';
export * from './status';
export * from './room';


export const CatalogCommonComponents = [
    ...NavItemsComponent,
    ...DepartmentComponents,
    ...ProjectComponents,
    ...ProgramComponents,
    ...StatusComponents,
    ...CategoryComponents,
    ...RoomComponents,
    ...RoomContentComponents
]